export default class Modal {
    constructor($el) {
        this.$el = $el;
        this.$modal = this.$el.querySelector('[data-modal]');
        this.$close = this.$modal.querySelector('[data-modal-close]');

        this.closeModal = this.closeModal.bind(this);

        if( ! this.$close) {
            return;
        }

        this.$close.addEventListener('click', this.closeModal);
        window.addEventListener('keydown', (e) => {
            if(e.key === "Escape") {
                this.closeModal(e);
            }
        });

        this.$el.addEventListener('click', (e) => {
            if( ! e.target.closest('[data-modal]')) {
                this.closeModal(e);
            }
        })
    }

    closeModal(e) {
        e.preventDefault();
        this.$modal.classList.remove('modal--open');
        this.$el.classList.remove('modal__container--open');
    }
}